<div class="trinka_cloud_wrap">
    <div id="particles-js"></div>
    <div class="cloud_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_text">
                        <h1>트링카 브라우저
                            <br /> 플러그인</h1>
                        <p>트링카를 브라우저로 확장하면 선호하는 웹사이트에서 포스팅과 메시지를 실시간으로 교정하고 개선할 수 있습니다. 이동 중에도 안전하고 성공적인 글을 작성해 보세요.</p>
                        <div id="BrowserGoogleChromeSection">
                            <div class="browserPluginButton">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                    class="buttonGoogleChrome" id="BrowserChromeButton">
                                    <b>
                                        <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                    </b>
                                    <i>크롬을 위한 설치</i>
                                </a>
                                <!-- <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" 
                            class="buttonFireFox" id="BrowserFireFoxButton">
                                <b>
                                    <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>파이어폭스를 위한 설치</i>
                            </a> -->
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox"> 또한 설치 가능
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> 가장자리 위한 설치
                                    </a>
                                </p>
                                <!-- <p class="ChromeAvalibale">
                                <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                    <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome"> 또한 설치 가능  
                                </a>
                            </p>
                            <p class="SafariComingSoon">
                                <img src="../../../assets/images/NewSafariIcon.svg" style="width: 32px;" alt="Grammar checker for Safari"> 곧 출시 예정
                            </p> -->
                            </div>
                        </div>
                        <div id="BrowserFirefoxSection">
                            <div class="browserPluginButton">
                                <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton">
                                    <b>
                                        <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>또한 설치 가능</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> 크롬을 위한 설치
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Chrome"> 가장자리 위한 설치
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div id="BrowserEdgeBrowserSection">
                            <div class="browserPluginButton">

                                <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                    class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                    <b>
                                        <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                    </b>
                                    <i>가장자리 위한 설치</i>
                                </a>
                            </div>
                            <br />
                            <div class="commingSoonSeciton">
                                <p class="FirefoxAvalibale">
                                    <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank">
                                        <img style="width: 32px;" src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Firefox"> 크롬을 위한 설치
                                    </a>
                                </p>
                                <p class="SafariComingSoon EdgeBrowserPlugin">
                                    <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank">
                                        <img style="width: 30px;" src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Chrome"> 또한 설치 가능
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="trinka_cloud_banner_img">
                        <img src="../../../assets/images/BrowserPlugin_banner.png" alt="banner">
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="brandLogo_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="brandlogo_heading">
                        <h2>트링카의 플러그인의 호환 플랫폼: </h2>
                    </div>
                    <div class="cover_wrapper">
                        <div id="client-logos" class="owl-carousel">
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/google-docs.png" alt="google doc">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client_inners">
                                    <img src="../../../assets/images/authorea.png" alt="authorea">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/researchgate.png" alt="researchgate">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client_inners">
                                    <img src="../../../assets/images/medium.png" alt="medium">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/writing-cooprative.png" alt="writing-cooprative">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/evernote.png" alt="evernote">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/notion.png" alt="notion">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/linked-in.png" alt="linkedin">
                                </div>
                            </div>
                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/twitter.png" alt="twitter">
                                </div>
                            </div>

                            <div class="item">
                                <div class="client-inners">
                                    <img src="../../../assets/images/gmail.png" alt="gmail">
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="viewfullList">
                        <!-- <a routerLink="/brand-list">View Full List</a> -->
                        … 그 외 다수
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="cloud_key_features">
        <div class="container">
            <div class="row">
                <div class="col-12-sm">
                    <div class="key_features_heading">
                        <h2>트링카 브라우저 플러그인의 주요 기능</h2>
                        <div class="HeadingSubLine"></div>
                        <p>트링카는 선호하는 브라우저에 따라 확장 형식으로 사용할 수 있으며 언제 어디서든 최상의 품질로 글이 작성되도록 도와줍니다. 실시간으로 교정과 제안을 받을 수 있으며, 수정된
                            내용도 모두 자동으로 검사하므로 내용이 누락될 걱정은 하지 않으셔도 됩니다. </p>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/realTimeEditing_icon.svg" alt="icon">
                        <h3>실시간 교정</h3>
                        <p>에디터가 교정을 제안하길 기다릴 필요 없이 트링카에서 글을 작성하면서 바로 교정을 받을 수 있습니다.</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-up" data-aos-duration="1000">
                        <img src="../../../assets/images/style_guide_icon.svg" alt="">
                        <h3>Style Guide Preferences</h3>
                        <p>Tailor the grammar & word choice of your manuscript to comply with popular academic style
                            guides (AMA 11th, AGU 2017).</p>
                    </div>
                </div> -->
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-left" data-aos-duration="1000">
                        <img src="../../../assets/images/subjectAreaAndDocumentType.svg" alt="">
                        <h3>Subject Area & Document Type</h3>
                        <p>Customize Trinka to provide you the most relevant suggestions based on your subject area and
                            type of manuscript.</p>
                    </div>
                </div> -->
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/AddtoDictionary.svg" alt="Dictionary">
                        <h3>사전에 추가</h3>
                        <p>“My Dictionary"에 단어를 추가하면 향후
                            <br /> 글에서는 트링카가 철자 오류로 표시하지
                            <br /> 않습니다.</p>
                    </div>
                </div>
                <!-- <div class="col-lg-4 col-md-6">
                    <div class="features_cards" data-aos="fade-up" data-aos-duration="1500">
                        <img src="../../../assets/images/DownloadTrackChangesEdit.svg" alt="">
                        <h3>Word Count Reduction</h3>
                        <p>Trinka makes wordy phrases concise to make your writing impactful and comply with journal guidelines.</p>
                    </div>
                </div> -->
                <div class="col-lg-4 col-md-6">
                    <div class="features_cards">
                        <img src="../../../assets/images/DataSecurityIcon.svg" alt="data-security">
                        <h3>데이터 보안</h3>
                        <p>입력한 내용을 안전하게 전송하고 분석합니다. 트링카는 데이터를 따로 저장하지 않습니다.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="writeToolboxs_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="writerBox_heading">
                        <h2>언제 어디서나 사용 가능한 트링카 브라우저 플러그인</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">

                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Google Docs에서 문법 수정을 받으세요</h2>
                            <p>Google Docs에서 더 나은 글을 쓰고 모든 문법 오류를 손쉽게 수정하길 원하시나요?</p>
                            <p>트링카의 브라우저 확장 프로그램을 설치하여 Google Docs에서 실시간 문법 및 철자 수정, 언어 개선을 받으세요.</p>
                            <!-- <a href="#">
                                Read More
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/google-doc-ss.jpg" alt="google" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                            <div class="col-sm-12">
                                <div class="writerBox_heading">
                                    <h2><span></span>How to write better on Authorea?</h2>
                                </div>
                            </div>
                        </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/authorea-ss.jpg" alt="authorea" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Authorea에서 글을 더 잘 쓰는 방법은 뭘까요?</h2>
                            <p>Authorea를 활용하여 글쓰기를 하시나요? 그렇다면 글의 품질을 높이기 위한 문법 수정 툴은 필수입니다!</p>
                            <p>트링카의 브라우저 플러그인을 사용하면 Authorea에서 실시간으로 문법 오류를 수정받아 더 나은 글쓰기를 할 수 있습니다.</p>
                            <!-- <a href="#">
                                Read More
                                <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                            </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="writeToolbox_inner_sections">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2><span></span>Correct your writing on Evernote</h2>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Evernote에서 글을 수정받으세요</h2>
                            <p>Evernote에서 작성하는 글의 품질을 높여보세요. AI 기반 글쓰기 툴인 트링카는 실시간으로 문법을 수정하고 언어 개선을 제공합니다.</p>
                            <p>트링카의 브라우저 확장 프로그램은 Evernote와 완벽하게 호환되고 쉽게 플러그인이 되므로 힘들이지 않고 글을 점검하고 수정할 수 있습니다.</p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                                </a> -->
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/evernote-ss.jpg" alt="evernote" class="img-fluid">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="writeToolbox_inner_sections writeToolbox_inner_sections_even" style="background-image: url('../../../assets/images/toolbox_backgrond_browser_plugin_r.png');background-position: right center;">
            <div class="container">
                <!-- <div class="row">
                                <div class="col-sm-12">
                                    <div class="writerBox_heading">
                                        <h2><span></span>Write better on Medium with Trinka</h2>
                                    </div>
                                </div>
                            </div> -->
                <div class="row">
                    <div class="col-lg-6">
                        <div class="toolbox_img_content">
                            <img src="../../../assets/images/medium-ss.jpg" alt="medium" class="img-fluid">
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="toolbox_text_content">
                            <h2>Medium에서 트링카를 활용하여 더 나은 글을 쓰세요</h2>
                            <p>Medium에서 블로그를 작성하시나요? 그렇다면 트링카의 무료 브라우저 플러그인이 제공하는 수정 기능을 놓치지 마세요.</p>
                            <p>트링카는 문법, 어조, 구두점, 문장 구조 등을 수정하고 전반적인 글의 품질을 높여 Medium 독자들의 눈길을 사로잡습니다. </p>
                            <!-- <a href="#">
                                    Read More
                                    <img src="../../../assets/images/ReadMoreArrow.png" alt="">
                                </a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>

    <div class="browser_plugin_cta">
        <div class="container">
            <div class="row">
                <div class="col-lg-12" id="BrowserGoogleChromeSection_cta">
                    <div class="trinka_cloud_banner_text">

                        <div class="browserPluginButton">
                            <a href="https://chrome.google.com/webstore/detail/trinka-ai-for-chrome/bbcmnbnmngpeofmpcdlcfalbniefegbp" target="_blank"
                                class="buttonGoogleChrome" id="BrowserChromeButton">
                                <b>
                                    <img src="../../../assets/images/NewChromeIcon.svg" alt="Grammar checker for Chrome">
                                </b>
                                <i>크롬을 위한 설치</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserFirefoxSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">
                            <a href="https://addons.mozilla.org/en-US/firefox/addon/trinka-ai-firefox-browser/" target="_blank" class="buttonFireFox" id="BrowserFireFoxButton_cta">
                                <b>
                                    <img src="../../../assets/images/NewFirefoxIcon.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>또한 설치 가능</i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col-lg-12" id="BrowserEdgeBrowserSection_cta">
                    <div class="trinka_cloud_banner_text">
                        <div class="browserPluginButton">

                            <a href="https://microsoftedge.microsoft.com/addons/detail/trinka-ai-for-edge/kjhkcgjfbpppkbhhaocagkmfkkiibeap" target="_blank"
                                class="buttonEdgeBrowser buttonGoogleChrome" id="BrowserEdgeButton">
                                <b>
                                    <img src="../../../assets/images/EdgeWhite_BGAndOutline.svg" alt="Grammar checker for Firefox">
                                </b>
                                <i>가장자리 위한 설치</i>
                            </a>
                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>



    <div class="use_trinka_other_app">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="use_trinka_content">
                        <div class="use_trinka_heading">
                            <div class="howItWorkHeading lineWhiteColor">
                                <h2>다른 앱에서
                                    <br /> 트링카 사용</h2>
                                <div class="HeadingSubLine"></div>
                            </div>
                        </div>
                        <div class="others_app_name">
                            <ul>
                                <li>
                                    <a href="https://www.trinka.ai/kr/trinkacloud">
                                        <div class="app_name_content" routerLink="">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_apps_TrinkaCloud.svg" alt="cloud">
                                            <h3>클라우드</h3>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/wordplugin">
                                        <div class="app_name_content">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Others_App_MSWord.svg" alt="ms word">
                                            <h3>MS Word
                                                <br /> 플러그인</h3>

                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.trinka.ai/kr/enterprise">
                                        <div class="app_name_content" style="padding: 0px;" routerLink="/enterprise">
                                            <div class="app_name_content_overlay"></div>
                                            <img src="../../../assets/images/Other_Apps_enterprise.svg" alt="enterprise">
                                            <h3 style="margin: 0 0 -2px 0;">기업</h3>
                                            <span style="font-size: 11px; color: #000; position: relative;">(API, JS & On-Premise)</span>
                                        </div>
                                    </a>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>